import * as React from "react";
import PropTypes from 'prop-types';

const SvgSuccess = props => {
  if (props.id !== "_svgsuccess") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h48v48H0z" /><path d="M24 11c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zm7.144 7.972a1.083 1.083 0 010 1.532l-9.384 9.383a1.08 1.08 0 01-1.533 0l-3.188-3.189a1.083 1.083 0 011.532-1.532l2.422 2.423 8.62-8.618a1.083 1.083 0 011.531 0z" fill="#01803F" /></g></svg>;
};

SvgSuccess.displayName = "_svgsuccess";
SvgSuccess.propTypes = {
  id: PropTypes.string
};
SvgSuccess.defaultProps = {
  id: ''
};
export default SvgSuccess;